'use client';

import { PropsWithChildren } from 'react';
import NextLink from 'next/link';
import { usePathname } from 'next/navigation';

import { Link as ChakraLink } from '@chakra-ui/next-js';
import { Button, ButtonProps, SystemStyleObject } from '@chakra-ui/react';

type LinkProps = PropsWithChildren & {
  to: string;
  color?: string;
  variant?: string;
  sx?: SystemStyleObject;
  external?: boolean;
  buttonProps?: ButtonProps;
};

const Link = ({
  to,
  color,
  variant,
  buttonProps,
  external = false,
  sx = {},
  children,
  ...rest
}: LinkProps) => {
  const pathname = usePathname();
  const isActive = pathname.includes(to);

  const linkStyles = {
    '& > svg': {
      width: 4,
      height: 4
    },
    '&.active-link': {
      textDecoration: 'none',
      fontWeight: 600
    },
    ...sx
  };

  return buttonProps ? (
    <Button
      as={NextLink}
      href={to}
      {...buttonProps}
      {...(external ? { target: '_blank' } : {})}
      {...rest}
    >
      {children}
    </Button>
  ) : (
    <ChakraLink
      display='inline-flex'
      alignItems='center'
      className={isActive ? 'active-link' : ''}
      variant={variant}
      gap={2}
      href={to}
      fontFamily='main'
      lineHeight='20px'
      _hover={{
        cursor: 'pointer'
      }}
      sx={linkStyles}
      {...(color ? { color } : {})}
      {...(external ? { target: '_blank' } : {})}
      {...rest}
    >
      {children}
    </ChakraLink>
  );
};

export default Link;
